import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import {PickupNoteSummary} from "../Pickups/PickupNoteSummary";
import { IsInRole, ROLE_Driver } from '../../constants';
import {getCollectionAction, getRunFlag, getRunFlagBadgeClass, getRunFlagIcon, getRunTypeCardStyle} from "../../utils/collectionTypes";

const DriverRunSummary = (props) => {
    let {run, onRunRefresh, account} = props;    

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="card" style={getRunTypeCardStyle(run.truckCollectionTypeCode)}>
                    <div className="card-block">
                        <h5 className="card-title">
                            {run.isComplete && <span className="badge badge-success">Run Complete</span>}
                            {!run.isComplete && <span className="badge badge-warning">Run Incomplete</span>}
                            <span className={getRunFlagBadgeClass(run.truckCollectionTypeCode) + ' ml-1'}><i className={getRunFlagIcon(run.truckCollectionTypeCode)}/> {getRunFlag(run.truckCollectionTypeCode)}</span>
                            {onRunRefresh &&
                            <span className="pull-right" style={{marginLeft: '10px'}}>
                                <a href="#" onClick={onRunRefresh}>
                                    <i className="fa fa-refresh">&nbsp;</i>
                                </a>
                            </span>}
                        </h5>
                        <h6>{run.runDate}<br/>
                            {run.dateModified !== '0001-01-01T00:00:00' &&
                            <span className="text-muted" style={{fontSize: 'small'}}>
        <i className="fa fa-save"/>&nbsp;{moment(run.dateModified).format('ddd, Do, LT')}</span>}
                        </h6>
                        <h4 style={{marginTop: '5px', marginBottom: '5px'}}
                            className="card-subtitle">{run.regionsVisited} - {run.truckName}</h4>
                        <h6>{run.driverFullName}</h6>
                        <p className="card-text"><i
                            className="fa fa-shopping-cart"/>&nbsp; {`${parseFloat(run.totalLitres).toFixed(0)} L to be ${getCollectionAction(run.truckCollectionTypeCode)}`}
                        </p>                        
                        <p className="card-text"><i
                            className="fa fa-battery-full"/>&nbsp; {`${parseFloat(run.totalEstimatedLitresPickedUp).toFixed(2)} L ${getCollectionAction(run.truckCollectionTypeCode)}`}
                        </p>
                        <p className="card-text"><i
                            className="fa fa-tachometer"/>&nbsp; {`${run.pickupsComplete}/${run.pickupsToComplete}`} locations
                            complete</p>
                        
                        { run.pickups.map(p => (!p.smsNoResponse) && IsInRole(account, ROLE_Driver) 
                                && <PickupNoteSummary pickup={p} key={p.id} />) }
                        
                        {(run.pickupsToComplete - run.pickupsComplete == 0) && run.isBaseCheckedIn && !run.isBaseCheckedOut &&
                        <p className="card-text text-danger"><i className="fa fa-warning"/> Must check out of final
                            location</p>}
                    </div>
                </div>
            </div>
        </div>);
};

DriverRunSummary.propTypes = {
    run: PropTypes.object.isRequired,
    onRunRefresh: PropTypes.func.isRequired,
};

export default DriverRunSummary;